export default __webpack_public_path__ + "static/media/Ip_address_tracker.7d878545.png";